import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, ExpenseVouchersController, ExpenseVouchersRequest, BillHeaderWithItemsController, BillHeaderWithItemsRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, RefundDetailsData, RefundDetailsRequest, RefundItemDetailsController } from '../../../../../../../src/app/ncs/models/actor/actor';
import { NgxSpinnerService } from 'ngx-spinner';




@Component({
  selector: 'iohvieworderPVindi',
  templateUrl: './iohvieworderPVindi.component.html',
  styleUrls: ['./iohvieworderPVindi.component.scss']
})

export class IohvieworderPVindiComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ActorCode: any;
  public FormattedCode: any;
  public Date: Date;
  public SelectedDay: any;
  public SelectedMonth: any;
  public SelectedYear: any;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public ItemsData: boolean = false;
  //pdata: any[];
  public IahOrderCode: any;
  public TotalAmount: any;
  public Gender: any;
  public CustomerName: any;
  public AgeY: any;
  public MobileNumber: any;
  public DeliverToAddress: any;
  public OrderDate: any;
  public OrderNo: any;
  public OrderStatus: any;
  public ItemName: any;
  public CreatedUser: any;
  public PrescName: any;



  CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;
  OocyteStorageDetails: IvfOocyteEmbryoStorageByCodeController;
  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    //this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    //this.ActorCode = this.route.snapshot.paramMap.get('ActorCodedata');
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;


          this.stopRefreshing();
          this.printService.onDataReady();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService, private spinner: NgxSpinnerService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();
    this.IahOrderCode = this.route.snapshot.paramMap.get('IahOrderCodeData');
    this.FormattedCode = this.route.snapshot.paramMap.get('FormattedCode');
    this.TotalAmount = this.route.snapshot.paramMap.get('TotalAmount');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.CustomerName = this.route.snapshot.paramMap.get('CustomerName');
    this.AgeY = this.route.snapshot.paramMap.get('AgeY');
    this.MobileNumber = this.route.snapshot.paramMap.get('MobileNumber');
    this.DeliverToAddress = this.route.snapshot.paramMap.get('DeliverToAddress');
    this.OrderDate = this.route.snapshot.paramMap.get('OrderDate');
    this.OrderNo = this.route.snapshot.paramMap.get('OrderNo');
    this.OrderStatus = this.route.snapshot.paramMap.get('OrderStatus');
    this.ItemName = this.route.snapshot.paramMap.get('ItemName');
    this.CreatedUser = this.route.snapshot.paramMap.get('CreatedUser');
    this.PrescName = this.route.snapshot.paramMap.get('PrescName');
    this.AddRow();
  

  }
  CurrentIohServiceitemData: Array<IohServiceitemData>;

  AddRow() {
    if (this.CurrentIohServiceitemData == null) {
      this.CurrentIohServiceitemData = new Array<IohServiceitemData>();
    }
    if (this.CurrentIohServiceitemData != null) {
      var row = new IohServiceitemData();
      row.ItemName = this.ItemName;
      row.OrderStatus = this.OrderStatus;
      this.CurrentIohServiceitemData.push(row);
      this.LoadOqaData();
    }

    // this.TotalBill = this.CurrentConsumptionGroupItemsController.filter((item) => item.ItemCost)
    //   .map((item) => +item.ItemCost)
    //  .reduce((sum, current) => sum + current);

    // this.BranchName = AppData.Instance().SelectedBranchName;
    // this.Date = new Date();
    //        alert(l.BasePrice);

    //this.AddData();

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
export class IohServiceitemData {

  public ItemName: string;
  public OrderStatus: string;

}
